var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 151,
    viewBox: "0 0 178 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.543 102.909C161.495 102.909 163.888 100.516 163.888 97.5642C163.888 94.6124 161.495 92.2195 158.543 92.2195C155.592 92.2195 153.199 94.6124 153.199 97.5642C153.199 100.516 155.592 102.909 158.543 102.909Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.28 117.821C150.295 117.821 151.93 116.186 151.93 114.171C151.93 112.155 150.295 110.521 148.28 110.521C146.264 110.521 144.63 112.155 144.63 114.171C144.63 116.186 146.264 117.821 148.28 117.821Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0117 28.6055C32.0275 28.6055 33.6617 26.9714 33.6617 24.9555C33.6617 22.9397 32.0275 21.3055 30.0117 21.3055C27.9958 21.3055 26.3617 22.9397 26.3617 24.9555C26.3617 26.9714 27.9958 28.6055 30.0117 28.6055Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72069 98.9981C11.4644 98.9981 14.4992 95.9632 14.4992 92.2195C14.4992 88.4758 11.4644 85.441 7.72069 85.441C3.977 85.441 0.942139 88.4758 0.942139 92.2195C0.942139 95.9632 3.977 98.9981 7.72069 98.9981Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0408 133.021C126.541 133.021 156.132 103.43 156.132 66.8C156.132 30.1698 126.541 0.578781 90.0408 0.578781C53.5409 0.578781 23.95 30.1698 23.95 66.8C23.95 103.43 53.5409 133.021 90.0408 133.021Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.423 10.5322C130.389 10.5322 132.052 12.0369 132.052 14.1436V120.68C132.052 122.636 130.54 124.291 128.423 124.291H49.6376C47.6717 124.291 46.0083 122.786 46.0083 120.68V14.1436C46.0083 12.1874 47.5205 10.5322 49.6376 10.5322H128.423Z",
    fill: "#CED7E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.052 21.6673V120.529C132.052 122.485 130.54 124.14 128.423 124.14H56.4425L50.0913 117.821L121.618 19.8616L127.818 17.6045L132.052 21.6673Z",
    fill: "#BCC4CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.121 18.8083C128.121 18.2064 127.667 17.6045 126.911 17.6045H51.3011C50.6962 17.6045 50.0913 18.0559 50.0913 18.8083V116.617C50.0913 117.219 50.545 117.821 51.3011 117.821H126.76C127.364 117.821 127.969 117.369 127.969 116.617L128.121 18.8083Z",
    fill: "#D9DFEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.12 18.8083C128.12 18.2064 127.667 17.6045 126.911 17.6045H51.3009C50.696 17.6045 50.0912 18.0559 50.0912 18.8083C50.9985 57.7812 51.3009 101.87 47.0668 113.306L119.501 112.253C123.886 92.3903 127.213 56.7279 128.12 18.8083Z",
    fill: "#EFF3FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_68_2218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.969 17.755C127.969 17.755 127.818 23.6235 126.003 61.0916C126.003 61.3926 126.003 61.5431 126.003 61.844C123.735 98.5598 91.0712 106.234 87.1395 106.685C85.3249 106.836 81.8468 107.137 75.6468 107.137C67.9346 107.438 56.1395 107.588 37.6907 107.739C37.0859 107.739 36.6322 107.137 36.9346 106.535C49.6371 81.1047 49.7883 17.9054 49.7883 17.9054L127.969 17.755Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.852 61.6935C123.735 98.4093 90.9205 106.084 86.9888 106.535C85.1741 106.685 81.6961 106.986 75.4961 106.986C91.8278 99.4626 100.599 85.9199 100.447 75.3867C108.311 75.9886 121.92 75.3867 125.852 61.6935Z",
    fill: "#EAEEF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.403 10.8331C107.403 10.6827 107.403 10.6827 107.403 10.8331L106.647 10.0808C106.647 10.0808 106.194 10.2312 106.042 10.5322H94.2473C94.2473 10.2312 94.2473 10.0808 94.2473 9.77982C94.2473 7.37223 92.1302 5.26559 89.7107 5.26559C87.2912 5.26559 85.1741 7.37223 85.1741 9.77982C85.1741 10.0808 85.1741 10.2312 85.3253 10.3817H73.0766C72.4717 10.3817 71.8668 10.8331 71.8668 11.736V15.6483C71.8668 18.6578 73.9839 20.4635 76.8571 20.4635H101.959C104.984 20.4635 107.555 18.6578 107.555 15.6483V11.5855C107.706 11.2846 107.555 10.9836 107.403 10.8331Z",
    fill: "#1C3754"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.95 10.8331V14.7455C106.95 15.0464 106.95 15.1969 106.95 15.4979C106.496 18.0559 104.379 20.1626 101.657 20.1626H76.4034C73.6814 20.1626 71.5644 18.0559 71.1107 15.4979C71.1107 15.1969 71.1107 15.0464 71.1107 14.7455V10.8331C71.1107 10.2312 71.5644 9.47887 72.3205 9.47887H84.7205C84.7205 9.17792 84.7205 9.02745 84.7205 8.87698C84.7205 6.46938 86.8375 4.36274 89.257 4.36274C91.6766 4.36274 93.7936 6.46938 93.7936 8.87698C93.7936 9.17792 93.7936 9.3284 93.7936 9.47887H106.194C106.496 9.62935 106.95 10.0808 106.95 10.8331Z",
    fill: "url(#paint0_linear_68_2218)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9546 10.9836C90.1644 10.9836 91.0717 10.0808 91.0717 8.87698C91.0717 7.67318 90.1644 6.77033 88.9546 6.77033C87.7448 6.77033 86.8375 7.67318 86.8375 8.87698C86.8375 10.0808 87.8961 10.9836 88.9546 10.9836Z",
    fill: "#EAEEF9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.798 15.4979C106.345 18.0559 104.228 20.1626 101.506 20.1626H76.4034C73.6814 20.1626 71.5644 18.0559 71.1107 15.4979H106.798Z",
    fill: "#9AA1B2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6912 61.2421C71.1107 61.2421 72.9253 59.2859 72.9253 57.0288C72.9253 54.6212 70.9595 52.8155 68.6912 52.8155C66.2717 52.8155 64.457 54.7717 64.457 57.0288C64.3058 59.2859 66.2717 61.2421 68.6912 61.2421Z",
    fill: "#989FB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.262 61.0916C104.681 61.0916 106.496 59.1355 106.496 56.8784C106.496 54.4708 104.53 52.6651 102.262 52.6651C99.9937 52.6651 98.0278 54.6212 98.0278 56.8784C98.0278 59.1355 99.8425 61.0916 102.262 61.0916Z",
    fill: "#989FB0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5595 65.7563H81.3937V67.7125H89.5595V65.7563Z",
    fill: "#989FB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M171.067 18.2064C174.394 33.8557 173.94 50.4079 169.403 65.7563C168.345 68.9163 167.286 72.3772 165.018 74.7848C161.842 78.5467 156.096 80.2019 151.408 78.9981C146.569 77.7943 142.638 73.581 141.73 68.4649C140.974 65.3049 142.033 61.5431 144.755 59.5869C147.628 57.7812 151.711 58.2326 154.13 60.4897C156.852 62.7469 157.911 66.2078 157.759 69.5182C157.608 72.8286 156.398 76.1391 154.735 78.9981C149.745 88.3275 140.672 95.7008 130.238 99.0112C122.525 101.419 114.208 101.419 106.496 99.3122",
    stroke: "#C9D4E2",
    strokeWidth: 2.60713,
    strokeMiterlimit: 10,
    strokeDasharray: "5.21 5.21"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.418 13.6922C176.964 15.3474 175.15 15.9493 173.335 14.896C171.369 13.9931 170.008 13.2407 170.311 11.736C170.764 10.2313 172.579 10.0808 174.696 9.9303C177.267 9.62935 177.72 12.0369 177.418 13.6922Z",
    fill: "#DAE2EB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M162.75 15.1969C163.506 16.5512 165.623 17.454 167.135 16.0998C168.799 14.595 170.159 13.5417 169.403 12.0369C168.647 10.6827 167.438 11.1341 164.867 11.435C162.75 11.8865 161.842 13.6922 162.75 15.1969Z",
    fill: "#DAE2EB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M169.403 9.62935C170.462 9.47888 171.52 10.0808 171.823 10.9836C171.974 11.2846 172.125 11.736 172.125 12.0369C172.428 14.1436 171.672 15.9493 170.462 16.0998C169.101 16.4007 167.74 14.896 167.589 12.9398C167.589 12.3379 167.589 12.0369 167.589 11.5855C167.74 10.5322 168.345 9.77983 169.403 9.62935C169.554 9.62935 169.403 9.62935 169.403 9.62935Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_68_2218",
    x: 8.1599,
    y: 3.41573,
    width: 148.487,
    height: 147.341,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14.3392
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.3392
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_68_2218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_68_2218",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_2218",
    x1: 71.154,
    y1: 12.2646,
    x2: 106.984,
    y2: 12.2646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNote);
export default __webpack_public_path__ + "static/media/empty-note.92139c2cfbeddcb6a3d51de906edc053.svg";
export { ForwardRef as ReactComponent };